import React from 'react';

const ArrowBackIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#rzythommna)">
        <path d="M7.147 15.353a.502.502 0 0 1 0-.706l4.5-4.5a.502.502 0 0 1 .706 0 .502.502 0 0 1 0 .706L8.706 14.5H22.5c.275 0 .5.225.5.5s-.225.5-.5.5H8.706l3.647 3.647a.502.502 0 0 1 0 .706.502.502 0 0 1-.706 0l-4.5-4.5z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="rzythommna">
          <path fill="#fff" transform="translate(7 7)" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowBackIcon;
